<template>
  <div class="home">
    <banner-carousel />

    <section class="stats-section bg-white">
      <div class="home-inner">
        <div class="stats-grid">
          <div class="stat-card text-center radius-8 light-1">
            <div class="stat-num text-bold">{{ technical_service_num }}</div>
            <div class="stat-label">技术服务</div>
          </div>
          <div class="stat-card text-center radius-8 light-2">
            <div class="stat-num text-bold">{{ service_case_num }}</div>
            <div class="stat-label">服务案例</div>
          </div>
          <div class="stat-card text-center radius-8 light-3">
            <div class="stat-num text-bold">{{ course_services_num }}</div>
            <div class="stat-label">课程服务</div>
          </div>
          <div class="stat-card text-center radius-8 light-4">
            <div class="stat-num text-bold">{{ supporting_resources_num }}</div>
            <div class="stat-label">配套资源</div>
          </div>
        </div>

        <div class="section-header">
          <p class="section-sub">深耕四大核心垂直领域</p>
          <h2 class="section-title">核心技术服务领域</h2>
        </div>

        <div class="core-grid">
          <router-link v-for="item in coreServices" :key="item.title" :to="item.path"
            class="core-card bg-white radius-8" style="background: #F8F9FA;border: 1px solid rgba(115,118,136,0.15);">
            <img class="core-icon" :src="item.icon" alt="">
            <h3 class="core-title text-bold">{{ item.title }}</h3>
            <div class="core-desc text-666-color ell">{{ item.desc }}</div>
            <div class="core-link flex align-center text-blue">
              查看更多
              <img src="@/assets/icon32.png" class="core-link-icon" alt="">
            </div>
          </router-link>
        </div>

        <div class="cta-section radius-20"
          :style="level_heading_bg ? { backgroundImage: `url(${level_heading_bg})` } : null">
          <div v-if="level_heading_one" class="cta-title">{{ level_heading_one }}</div>
          <div v-if="level_heading_two" class="cta-subtitle">{{ level_heading_two }}</div>
          <button v-if="showApplyEngineerBtn" type="button" class="cta-btn"
            @click="handleApplyEngineer">申请成为工程师</button>
        </div>
      </div>
    </section>

    <section class="engineer-section">
      <div class="home-inner">
        <div class="section-block">
          <div class="section-sub text-999-color">连接各领域的行业权威</div>
          <div class="section-head">
            <h2 class="section-title text-bold">技术工程师</h2>
            <router-link to="/engineer" class="view-more-link text-blue">查看更多</router-link>
          </div>
        </div>

        <div class="card-grid">
          <div v-for="eng in engineer_list" :key="eng.id" class="engineer-card bg-white radius-8"
            @click="goEngineerDetail(eng.id)">
            <div class="engineer-card-top text-center">
              <img class="engineer-avatar radius-50" :src="eng.avatar_url" :alt="eng.nickname">
              <h3 class="engineer-name">{{ eng.nickname }}</h3>
              <p class="engineer-no text-blue">{{ eng.engineer_no }}</p>
              <div class="engineer-tags flex align-center justify-start flex-wrap">
                <div v-for="tag in eng.tags" :key="tag.id" class="engineer-tag bg-F7 radius-2">
                  {{ tag.name }}
                </div>
              </div>
            </div>
            <div class="engineer-card-bottom solid radius-12">
              <div class="flex">
                <el-rate :value="eng.rating" disabled text-color="#fbbd08" />
                <span>{{ eng.rating }}</span>
              </div>
              <div class="engineer-intro text-666-color">{{ eng.basic_intro }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="product-section bg-white">
      <div class="home-inner">
        <div class="section-block">
          <div class="section-sub text-999-color">寻找专业知识的开放项目</div>
          <div class="section-head">
            <h2 class="section-title text-bold">技术服务</h2>
            <router-link to="/service" class="view-more-link view-more-link--light text-blue">查看更多</router-link>
          </div>
        </div>

        <div v-if="technical_service_list.length" class="card-grid">
          <div v-for="prod in technical_service_list" :key="prod.id" class="product-card bg-white radius-8"
            @click="goServiceDetail(prod.id)">
            <div class="product-card-body flex align-start">
              <img v-if="prod.publisher_info && prod.publisher_info.avatar_url" :src="prod.publisher_info.avatar_url"
                class="product-avatar radius-50" alt="">
              <div class="product-main flex-sub">
                <h3 class="product-title">{{ maskText(prod.title, 8) }}</h3>
                <span class="product-time">项目发布日期 : {{ formatDate(prod.publishtime) }}</span>
                <div class="product-time">期望完成日期 : {{ prod.expect_finishtime }}</div>
              </div>
            </div>
            <div class="product-card-foot flex align-center justify-between">
              <p class="product-price text-main">{{ maskText(prod.budget_text, 2) }}</p>
              <div class="product-detail-btn text-blue">查看详情 》</div>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无技术服务" />
      </div>
    </section>

    <el-dialog :visible.sync="applyEngineerVisible" width="500px" custom-class="publish-success-dialog"
      :show-close="false" append-to-body center>
      <div class="success-modal flex flex-direction align-center">
        <img :src="applyEngineerDialogIcon" class="success-icon" alt="">
        <p class="success-text">{{ applyEngineerDialogText }}</p>
        <div v-if="reason && user.engineer_status == 'rejected'" class="text-color-666 _reason">{{ reason }}</div>
        <button v-if="user.engineer_status === 'rejected'" type="button" class="resubmit-btn" @click="handleResubmit">
          重新提交
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { getHomepageRecommend, getHomepageStats, getConfig } from '@/api/index'
import { fetchUserInfo, fetchUserStats } from '@/api/user'

export default {
  name: 'HomeView',
  data() {
    return {
      reason: '',
      technical_service_num: 0,
      service_case_num: 0,
      course_services_num: 0,
      supporting_resources_num: 0,
      applyEngineerVisible: false,
      user: {
        engineer_status: ''
      },
      coreServices: [{
        icon: require('@/assets/icon31.png'),
        title: '技术服务',
        desc: '覆盖工业自动化、系统架构 设计及核心算法优化。',
        path: '/service'
      },
      {
        icon: require('@/assets/icon28.png'),
        title: '服务案例',
        desc: '汇集全球逾500个高精尖工 程项目实操经验与数据。',
        path: '/cases'
      },
      {
        icon: require('@/assets/icon29.png'),
        title: '课程服务',
        desc: '为企业团队提供最前沿的工 程技术闭环内训与认证。',
        path: '/course'
      },
      {
        icon: require('@/assets/icon30.png'),
        title: '配套资源',
        desc: '提供顶尖超算集群租赁与高 性能硬件定制化方案。',
        path: '/resource'
      }],
      engineer_list: [],
      technical_service_list: [],
      level_heading_bg: '',
      level_heading_one: '',
      level_heading_two: ''
    }
  },
  computed: {
    canGoApplyEngineer() {
      const status = this.user.engineer_status
      return !status || status === 'none' || status === 'draft'
    },
    showApplyEngineerBtn() {
      const status = this.user.engineer_status
      if (this.user.identity_type === 'engineer' || this.user.roles === 'engineer') return false
      if (status === 'approved') return false
      return true
    },
    isEngineer() {
      return this.user.identity_type === 'engineer' ||
        this.user.roles === 'engineer' ||
        this.user.engineer_status === 'approved'
    },
    applyEngineerDialogIcon() {
      const status = this.user.engineer_status
      if (status === 'pending' || status === 'draft') {
        return require('@/assets/icon11.png')
      }
      if (status === 'rejected' || status === 'closed') {
        return require('@/assets/icon10.png')
      }
      return require('@/assets/icon9.png')
    },
    applyEngineerDialogText() {
      const status = this.user.engineer_status
      this.reason = this.user.reason
      if (status === 'pending' || status === 'draft') {
        return '审核中'
      }
      if (status === 'rejected') {
        return '提交审核失败'
      }
      if (status === 'closed') {
        return '已下架'
      }
      return '欢迎您，工程师'
    }
  },
  created() {
    this.fetchHomepageStats()
    this.fetchHomeData()
    this.fetchConfig()
    this.loadUserEngineerStatus()
    eventBus.$on('auth:changed', this.loadUserEngineerStatus)
  },
  beforeDestroy() {
    eventBus.$off('auth:changed', this.loadUserEngineerStatus)
  },
  methods: {
    maskText(text, keep) {
      const str = text == null ? '' : String(text)
      if (this.isEngineer || !str) return str
      const visible = str.slice(0, keep)
      const hiddenLen = Math.max(str.length - keep, 2)
      return visible + '*'.repeat(Math.min(hiddenLen, 6))
    },
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(Number(timestamp) * 1000)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    loadUserEngineerStatus() {
      const loggedIn = sessionStorage.getItem('isLoggedIn') === '1' && !!sessionStorage.getItem('token')
      if (!loggedIn) {
        this.user = { engineer_status: '' }
        return
      }
      fetchUserInfo()
        .then((res) => {
          const data = res.data || {}
          Object.assign(this.user, data)
        })
        .catch(() => { })
    },
    fetchConfig() {
      getConfig()
        .then((res) => {
          const data = res.data || {}
          this.level_heading_bg = data.level_heading_bg || ''
          this.level_heading_one = data.level_heading_one || ''
          this.level_heading_two = data.level_heading_two || ''
        })
        .catch(() => { })
    },
    fetchHomepageStats() {
      getHomepageStats()
        .then((res) => {
          const data = res.data || {}
          this.technical_service_num = data.technical_service_num || 0
          this.service_case_num = data.service_case_num || 0
          this.course_services_num = data.course_services_num || 0
          this.supporting_resources_num = data.supporting_resources_num || 0
        })
    },
    fetchHomeData() {
      getHomepageRecommend()
        .then((res) => {
          const data = res.data || {}
          this.engineer_list = data.engineer_list || []
          this.technical_service_list = data.technical_service_list || []
        })
        .catch(() => {
          this.engineer_list = []
          this.technical_service_list = []
        })
    },
    handleApplyEngineer() {
      if (sessionStorage.getItem('isLoggedIn') !== '1' || !sessionStorage.getItem('token')) {
        eventBus.$emit('auth:unauthorized')
        return
      }
      Promise.all([fetchUserInfo(), fetchUserStats()])
        .then(([infoRes, statsRes]) => {
          const data = { ...(infoRes.data || {}), ...(statsRes.data || {}) }
          Object.assign(this.user, data)
          if (this.canGoApplyEngineer) {
            this.$router.push('/profile-setup')
          } else {
            this.applyEngineerVisible = true
          }
        })
    },
    handleResubmit() {
      this.applyEngineerVisible = false
      this.$router.push({ path: '/profile-setup', query: { resubmit: '1' } })
    },
    goEngineerDetail(id) {
      this.$router.push(`/engineer/${id}`)
    },
    goServiceDetail(id) {
      this.$router.push(`/service/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: #f5f5f5;
  max-width: 100%;
  overflow-x: hidden;
}

.home-inner {
  width: 79%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.stats-grid,
.core-grid,
.card-grid {
  display: grid;
  gap: 1.25rem;
}

.stats-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.core-grid,
.card-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.stats-section {
  padding: 2.5rem 0;
  margin-top: -1.25rem;
  position: relative;
  z-index: 3;
}

.engineer-section {
  padding: 3.75rem 0;
}

.product-section {
  padding: 3.75rem 0;
}

.section-header {
  margin: 2.5rem 0;
}

.section-block {
  margin-bottom: 1.875rem;
}

.section-sub {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.section-title {
  font-size: 2.0rem;
  line-height: 1.2;
  color: #0b1c30;
}

.section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  padding-top: 1.25rem;
}

.stat-card {
  height: 8.5625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1.25rem;
  box-sizing: border-box;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-0.25rem);
  }

  &.light-1 {
    color: #2f374a !important;
    background-color: #e6f5ec !important;
  }

  &.light-2 {
    color: #2f374a !important;
    background-color: #e6ebf5 !important;
  }

  &.light-3 {
    color: #2f374a !important;
    background-color: #f5e6eb !important;
  }

  &.light-4 {
    color: #2f374a !important;
    background-color: #f5f1e6 !important;
  }
}

.stat-num {
  font-size: 2.25rem;
  line-height: 1.1;
}

.stat-label {
  margin-top: 0.5rem;
  font-size: 0.875rem;
}

.core-card {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 1.5rem;
  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, transform 0.2s;
  text-decoration: none;
  color: inherit;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 0.375rem 1.25rem rgba(0, 0, 0, 0.1);
    transform: translateY(-0.25rem);
  }
}

.core-icon {
  width: 3.5rem;
  height: 3.5rem;
  object-fit: contain;
}

.core-title {
  margin: 1.875rem 0 0.75rem;
  font-size: 1.125rem;
  color: #0b1c30;
}

.core-desc {
  min-height: 2.75rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.375rem;
  max-width: 192px;
}

.core-link {
  margin-top: auto;
  font-size: 0.75rem;
}

.core-link-icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 0.25rem;
}

.cta-section {
  height: 25rem;
  margin: 3.125rem 0;
  //background-image: url('../assets/icon26.png'); 
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 2rem;
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #fff;
  line-height: 1.3;
  text-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.25);
}

.cta-subtitle {
  margin-top: 0.75rem;
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.5;
  text-shadow: 0 0.0625rem 0.5rem rgba(0, 0, 0, 0.2);
}

.cta-btn {
  margin-top: 1.75rem;
  min-width: 11.5rem;
  height: 4.75rem;
  padding: 0 2.75rem;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1;
  background: rgba(255, 255, 255, 0.22);
  border: 0.0625rem solid rgba(255, 255, 255, 0.55);
  border-radius: 1rem;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: background 0.2s, transform 0.2s, box-shadow 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.32);
    transform: translateY(-0.0625rem);
    box-shadow: 0 0.375rem 1.25rem rgba(0, 0, 0, 0.12);
  }

  &:active {
    transform: translateY(0);
  }
}

.engineer-card,
.product-card {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}

.product-card {
  min-height: 106%;
}

.engineer-card {
  padding: 1.5rem;
  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.06);

  &:hover {
    box-shadow: 0 0.375rem 1.25rem rgba(0, 0, 0, 0.1);
    transform: translateY(-0.25rem);
  }
}

.engineer-avatar {
  width: 8rem;
  height: 8rem;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.engineer-name {
  margin: 1.875rem 0 0;
  font-size: 1.5rem;
  color: #0b1c30;
}

.engineer-no {
  margin: 0.625rem 0 1.25rem;
  font-size: 0.875rem;
}

.engineer-tags {
  height: 3.75rem;
  overflow: hidden;
  align-content: flex-start;
}

.engineer-tag {
  padding: 0.25rem 0.75rem;
  margin: 0 0.5rem 0.375rem 0;
  font-size: 0.75rem;
  line-height: 1.25rem;
  white-space: nowrap;
}

.engineer-card-bottom {
  margin-top: 1rem;
  padding: 0.9375rem;
}

.engineer-intro {
  min-height: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  text-overflow: ellipsis;
  word-break: break-all;
}

.product-card {
  align-items: stretch;
  width: 100%;
  padding: 1.25rem;
  border: 0.0625rem solid #e2e8f0;
  background: #fff;
  box-shadow: 0 0.25rem 0.75rem rgba(15, 23, 42, 0.06);

  &:hover {
    border-color: #dbeafe;
    box-shadow: 0 0.5rem 1.5rem rgba(15, 23, 42, 0.1);
    transform: translateY(-0.125rem);

    .product-avatar {
      transform: scale(1.04);
    }

    .product-detail-btn {
      color: #fff;
      background: #2353cd;
      border-color: #2353cd;
    }
  }
}

.product-card-body {
  width: 100%;
  gap: 0.875rem;
  min-height: 3.75rem;
}

.product-avatar {
  width: 3.25rem;
  height: 3.25rem;
  object-fit: cover;
  flex-shrink: 0;
  background: #f1f5f9;
  transition: transform 0.2s;
}

.product-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.375rem;
}

.product-title {
  width: 100%;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.45;
  height: 2.9rem;
  color: #0b1c30;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  word-break: break-all;
}

.product-time {
  font-size: 0.75rem;
  color: #94a3b8;
  line-height: 1.2;
}

.product-card-foot {
  width: 100%;
  margin-top: 1rem;
  padding-top: 0.875rem;
  gap: 0.75rem;
  border-top: 0.0625rem solid #f1f5f9;
}

.product-price {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.2;
  min-width: 0;
}

.product-detail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  padding: 0 0.875rem;
  font-size: 0.8125rem;
  border: 0.0625rem solid rgba(35, 83, 205, 0.25);
  border-radius: 999rem;
  flex-shrink: 0;
  white-space: nowrap;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}

.view-more-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 7.0625rem;
  height: 2.875rem;
  padding: 0 1rem;
  font-size: 0.875rem;
  text-decoration: none;
  border: 0.0625rem solid #e2e8f0;
  border-radius: 0.5rem;
  transition: border-color 0.2s, background 0.2s;
  flex-shrink: 0;

  &:hover {
    border-color: #2342c9;
    background: #f8fafc;
  }

  &--light {
    background: #f8fafc;
  }
}

.success-icon {
  width: 9.375rem;
  height: 9.375rem;
  display: block;
  object-fit: contain;
}

.success-modal {
  text-align: center;
}

.success-text {
  margin: 1.5rem 0;
  font-size: 1.25rem;
  color: #64748b;
}

.resubmit-btn {
  width: 100%;
  max-width: 20rem;
  height: 2.75rem;
  margin-top: 2rem;
  font-size: 1rem;
  color: #fff;
  background: #009d42;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background: #008a3a;
  }
}
</style>

<style lang="scss">
.publish-success-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 48px 40px 56px;
  }

  ._reason {
    width: 315px;
    height: 60px;
    line-height: 60px;
    background: #FFF4F4;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #E00000;
    font-size: 14px;
  }
}
</style>
